module.exports = __webpack_public_path__ + "static/img/dev2.0511252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/development/dev2.jpg
// module id = 723H
// module chunks = 0